import React, { useRef, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
// import moreIcon from '../../../../media/shared-access/ic-more.svg'
// import mail from '../../../../media/shared-access/ic-mail.svg'
import Tabs, { Tab } from 'react-best-tabs'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import '../style/addcontact.scss'
import { deleteContact } from '../core/_requests'
import { useAuth } from '../../../../app/modules/auth'
import { toast } from 'react-toastify'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import DeleteModal from './delete-confirmation'
import { useIntl } from 'react-intl'
import threeDots from '../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import brandingConfig from '../../../../config/brandingConfig'

type ContactDetailsProps = {
  selectedContact: any
  setselectedContact: any
  contacts: any
  setcontacts: any
  handleContactOptions: any
  isUserConnected: any
  setIsNewContactActive: any
}

export const ContactDetails = ({
  selectedContact,
  setselectedContact,
  contacts,
  setcontacts,
  isUserConnected,
  handleContactOptions,
  setIsNewContactActive,
}: ContactDetailsProps) => {
  const { companyId, currentUser } = useAuth()
  const { formatMessage } = useIntl()
  const [menuVisible, setMenuVisible] = useState(false) // eslint-disable-line
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false) // State to manage modal visibility
  const [isDeleting, setIsDeleting] = useState(false)

  const [showKebabMenu, setShowKebabMenu] = useState(false)
  console.log('notes checking ', selectedContact)

  // function handleMenuVisible() {
  //   setMenuVisible((p) => !p)
  // }
  function setKey(tab: number): void {
    throw new Error(formatMessage({ id: 'Function not implemented.' }))
  }

  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowKebabMenu(false)
    }
  }

  useEffect(() => {
    // Attach the event listener
    document.addEventListener('mousedown', handleClickOutside)

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  // const handleClickOutside = (event: MouseEvent) => {
  //   if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
  //     setMenuVisible(false)
  //   }
  // }
  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      const {
        data: { success, errors },
      } = await deleteContact(companyId!, selectedContact.id)
      if (success) {
        toast.success(formatMessage({ id: 'Contact deleted successfully.' }))
        setcontacts((p: any) => p.filter((contact: any) => contact.id !== selectedContact.id))
        setselectedContact({})
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DeleteContactSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              contact_id: selectedContact.id,
              object_type: selectedContact.object,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DeleteContactFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              contact_id: selectedContact.id,
              object_type: selectedContact.object,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: errors[0],
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DeleteContactFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            contact_id: selectedContact.id,
            object_type: selectedContact.object,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setIsDeleting(false)
      setIsDeleteModalOpen(false)
    }
  }
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  const wrapperRef = useRef<HTMLDivElement>(null)
  const isEmptyObject = (obj: any) => Object.keys(obj).length === 0

  if (!isEmptyObject(selectedContact)) {
    return (
      <div ref={wrapperRef} className='card' id='kt_contacts_main'>
        <div className='card-header' id='kt_chat_contacts_header'>
          <div className=' card-title m-0'>
            <h2 className='fw-bold m-0'>{formatMessage({ id: 'Contact Details' })}</h2>
          </div>
          <div className='card-toolbar m-0 gap-2'>
            {/* <Link
              to='#'
              className='btn btn-sm btn-icon btn-active-light-secondary bg-white border border-1 '
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
            >
              <img src={mail} alt={formatMessage({id: 'mail'})} />
            </Link> */}
            {/* <Dropdown className='dropdown-container'>
              <Dropdown.Toggle
                className='bi bi-three-dots-vertical text-xl p-1'
                style={{ fontSize: '20px' }}
              ></Dropdown.Toggle>
              <Dropdown.Menu className='m-2 p-0'>
                <Dropdown.Item
                  className='text-dark font-size-12 dark-color-hover'
                  onClick={() => {
                    setselectedContact(selectedContact)
                    handleContactOptions('Edit')
                    setMenuVisible(false)
                  }}
                >
                  {formatMessage({ id: 'Edit' })}
                </Dropdown.Item>
                <Dropdown.Item
                  className='text-danger font-size-12 dark-color-hover'
                  onClick={() => {
                    setIsDeleteModalOpen(true)
                    setMenuVisible(false)
                  }}
                >
                  {formatMessage({ id: 'Delete' })}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
            <div className='position-relative'>
              <div
                className='p-2 cursor-pointer bg-white rounded-2 d-flex justify-content-center align-items-center'
                onClick={() => setShowKebabMenu(!showKebabMenu)}
              >
                <img src={threeDots} alt='' width={12} height={12} />
              </div>
              {showKebabMenu && (
                <div
                  className='card shadow rounded top-4 cursor-pointer z-index-1 position-absolute w-150px'
                  style={{ top: '40px', right: 0 }}
                  ref={dropdownRef}
                >
                  <div className='border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100'>
                    <button
                      type='button'
                      className='m-0 border-0 bg-transparent text-dark font-size-12 hover-muted'
                      onClick={() => {
                        setselectedContact(selectedContact)
                        handleContactOptions('Edit')
                        setMenuVisible(false)
                      }}
                    >
                      {formatMessage({ id: 'Edit' })}
                    </button>
                  </div>
                  <div className='border-0 border-gray-300 p-2 dropdown-items w-100'>
                    <button
                      type='button'
                      className='m-0 border-0 bg-transparent text-danger font-size-12 hover-muted'
                      onClick={() => {
                        setIsDeleteModalOpen(true)
                        setMenuVisible(false)
                      }}
                    >
                      {formatMessage({ id: 'Delete' })}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <DeleteModal
          isOpen={isDeleteModalOpen}
          onRequestClose={() => {
            if (!isDeleting) {
              setIsDeleteModalOpen(false)
            }
          }}
          onDelete={handleDelete}
          isDeleting={isDeleting}
        />

        <div className='card-body-padd'>
          <InfoCard2
            title='Comprehensive Contact Overview'
            desc='Access all the details of a contact in one place, including their schedule and calendar, to effortlessly coordinate and schedule meetings collaboratively based on availability.'
            slug={brandingConfig.helpLinks.sharedAccessContactDetails}
          />

          <div className='d-flex gap-7 align-items-center'>
            <div className='symbol symbol-circle symbol-100px'>
              <img src={selectedContact?.pictureUrl} alt={formatMessage({ id: 'User Profile' })} />
            </div>
            <div className='d-flex flex-column gap-2'>
              <h3 className='mb-0'>{selectedContact?.givenName}</h3>
              <div className='d-flex align-items-center gap-2'>
                <Link to='#' className='text-muted text-hover-primary'>
                  {selectedContact?.emails?.length > 0 && selectedContact?.emails[0].email}
                </Link>
              </div>
              <div className='d-flex align-items-center gap-2'>
                <Link to='#' className='text-muted text-hover-primary'>
                  {selectedContact?.phoneNumbers?.length > 0 &&
                    selectedContact?.phoneNumbers[0]?.number}
                </Link>
              </div>
            </div>
          </div>

          <Tabs
            activeTab={1}
            className='font-size-13'
            ulClassName='text-muted dark-border setting-tabs'
            activityClassName='bg-primary'
            onClick={(event, tab) => setKey(tab)}
          >
            <Tab title={formatMessage({ id: 'General' })} className='mr-3 mt-2'>
              <div
                className='tab-pane fade show active'
                id='kt_contact_view_general'
                role='tabpanel'
              >
                <div className='d-flex flex-column gap-5 mt-7'>
                  <div className='d-flex flex-column gap-1'>
                    <div className='fw-bold text-muted'>{formatMessage({ id: 'Company Name' })}</div>
                    <div className='fw-bold fs-5'>{selectedContact?.companyName || '-'}</div>
                  </div>
                  <div className='d-flex flex-column gap-1'>
                    <div className='fw-bold text-muted'>{formatMessage({ id: 'City' })}</div>
                    <div className='fw-bold fs-5'>
                      {selectedContact?.physicalAddresses?.[0]?.city || '-'}
                    </div>
                  </div>
                  <div className='d-flex flex-column gap-1'>
                    <div className='fw-bold text-muted'>{formatMessage({ id: 'Country' })}</div>
                    <div className='fw-bold fs-5'>
                      {selectedContact?.physicalAddresses?.[0]?.country || '-'}
                    </div>
                  </div>
                  <div className='d-flex flex-column gap-1'>
                    <div className='fw-bold text-muted'>{formatMessage({ id: 'Notes' })}</div>
                    <p>{selectedContact?.notes || '-'}</p>
                  </div>
                  <div className='d-flex flex-column gap-1'>
                    <div className='fw-bold text-muted'>{formatMessage({ id: 'Phone' })}</div>
                    <p>{selectedContact?.phoneNumbers[0]?.number || '-'}</p>
                  </div>
                </div>
              </div>
            </Tab>

            <Tab title={formatMessage({ id: 'Meetings' })} className='mr-3 mt-2'>
              <div className='mt-4'>
                <ul className='nav nav-pills d-flex flex-stack flex-nowrap scroll-x pb-2'>
                  <li className='nav-item me-1'>
                    <Link
                      className='nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 text-gray-900 text-active-white btn-active-primary'
                      data-bs-toggle='tab'
                      to='#kt_schedule_day_0'
                    >
                      <span className='opacity-50 fs-7 fw-semibold'>
                        {formatMessage({ id: 'Su' })}
                      </span>
                      <span className='fs-6 fw-bold'>{formatMessage({ id: '22' })}</span>
                    </Link>
                  </li>
                  <li className='nav-item me-1'>
                    <Link
                      className='nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 text-gray-900 text-active-white btn-active-primary active'
                      data-bs-toggle='tab'
                      to='#kt_schedule_day_1'
                    >
                      <span className='opacity-50 fs-7 fw-semibold'>Mo</span>
                      <span className='fs-6 fw-bold'>23</span>
                    </Link>
                  </li>
                  <li className='nav-item me-1'>
                    <Link
                      className='nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 text-gray-900 text-active-white btn-active-primary'
                      data-bs-toggle='tab'
                      to='#kt_schedule_day_2'
                    >
                      <span className='opacity-50 fs-7 fw-semibold'>Tu</span>
                      <span className='fs-6 fw-bold'>24</span>
                    </Link>
                  </li>
                  <li className='nav-item me-1'>
                    <Link
                      className='nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 text-gray-900 text-active-white btn-active-primary'
                      data-bs-toggle='tab'
                      to='#kt_schedule_day_3'
                    >
                      <span className='opacity-50 fs-7 fw-semibold'>We</span>
                      <span className='fs-6 fw-bold'>25</span>
                    </Link>
                  </li>
                  <li className='nav-item me-1'>
                    <Link
                      className='nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 text-gray-900 text-active-white btn-active-primary'
                      data-bs-toggle='tab'
                      to='#kt_schedule_day_4'
                    >
                      <span className='opacity-50 fs-7 fw-semibold'>Th</span>
                      <span className='fs-6 fw-bold'>26</span>
                    </Link>
                  </li>
                  <li className='nav-item me-1'>
                    <Link
                      className='nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 text-gray-900 text-active-white btn-active-primary'
                      data-bs-toggle='tab'
                      to='#kt_schedule_day_5'
                    >
                      <span className='opacity-50 fs-7 fw-semibold'>Fr</span>
                      <span className='fs-6 fw-bold'>27</span>
                    </Link>
                  </li>
                  <li className='nav-item me-1'>
                    <Link
                      className='nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 text-gray-900 text-active-white btn-active-primary'
                      data-bs-toggle='tab'
                      to='#kt_schedule_day_6'
                    >
                      <span className='opacity-50 fs-7 fw-semibold'>Sa</span>
                      <span className='fs-6 fw-bold'>28</span>
                    </Link>
                  </li>
                  <li className='nav-item me-1'>
                    <Link
                      className='nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 text-gray-900 text-active-white btn-active-primary'
                      data-bs-toggle='tab'
                      to='#kt_schedule_day_7'
                    >
                      <span className='opacity-50 fs-7 fw-semibold'>Su</span>
                      <span className='fs-6 fw-bold'>29</span>
                    </Link>
                  </li>
                  <li className='nav-item me-1'>
                    <Link
                      className='nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 text-gray-900 text-active-white btn-active-primary'
                      data-bs-toggle='tab'
                      to='#kt_schedule_day_8'
                    >
                      <span className='opacity-50 fs-7 fw-semibold'>Mo</span>
                      <span className='fs-6 fw-bold'>30</span>
                    </Link>
                  </li>
                  <li className='nav-item me-1'>
                    <Link
                      className='nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 text-gray-900 text-active-white btn-active-primary'
                      data-bs-toggle='tab'
                      to='#kt_schedule_day_9'
                    >
                      <span className='opacity-50 fs-7 fw-semibold'>Tu</span>
                      <span className='fs-6 fw-bold'>31</span>
                    </Link>
                  </li>
                </ul>
                <div className='tab-content'>
                  <div id='kt_schedule_day_0' className='tab-pane fade show'>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-info rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          16:30 - 17:30
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Sales Pitch Proposal
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Terry Robins</Link>
                        </div>
                      </div>

                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        {formatMessage({ id: 'View' })}
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-success rounded top-0 start-0'></div>
                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          11:00 - 11:45
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>
                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Lunch & Learn Catch Up
                        </Link>
                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Karina Clarke</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        {formatMessage({ id: 'View' })}
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-warning rounded top-0 start-0'></div>
                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          11:00 - 11:45
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>
                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Dashboard UI/UX Design Review
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Caleb Donaldson</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        {formatMessage({ id: 'View' })}
                      </Link>
                    </div>
                  </div>
                  <div id='kt_schedule_day_1' className='tab-pane fade show active'>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-success rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          9:00 - 10:00
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>
                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Creative Content Initiative
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Sean Bean</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        {formatMessage({ id: 'View' })}
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-success rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          16:30 - 17:30
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Sales Pitch Proposal
                        </Link>
                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Karina Clarke</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        {formatMessage({ id: 'View' })}
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-warning rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          9:00 - 10:00
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Project Review & Testing
                        </Link>
                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Peter Marcus</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        {formatMessage({ id: 'View' })}
                      </Link>
                    </div>
                  </div>
                  <div id='kt_schedule_day_2' className='tab-pane fade show'>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-warning rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          11:00 - 11:45
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Development Team Capacity Review
                        </Link>
                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Bob Harris</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        {formatMessage({ id: 'View' })}
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-success rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          12:00 - 13:00
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Project Review & Testing
                        </Link>
                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Michael Walters</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        {formatMessage({ id: 'View' })}
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-warning rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          14:30 - 15:30
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Development Team Capacity Review
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>David Stevenson</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        {formatMessage({ id: 'View' })}
                      </Link>
                    </div>
                  </div>
                  <div id='kt_schedule_day_3' className='tab-pane fade show'>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-danger rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          11:00 - 11:45
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Creative Content Initiative
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Caleb Donaldson</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-warning rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          16:30 - 17:30
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Sales Pitch Proposal
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Mark Randall</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-warning rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          12:00 - 13:00
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>
                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Lunch & Learn Catch Up
                        </Link>
                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Mark Randall</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                  </div>
                  <div id='kt_schedule_day_4' className='tab-pane fade show'>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-danger rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          16:30 - 17:30
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Weekly Team Stand-Up
                        </Link>
                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Michael Walters</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-info rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          10:00 - 11:00
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Committee Review Approvals
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Kendell Trevor</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-success rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          13:00 - 14:00
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Dashboard UI/UX Design Review
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Mark Randall</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                  </div>
                  <div id='kt_schedule_day_5' className='tab-pane fade show'>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-info rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          14:30 - 15:30
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Team Backlog Grooming Session
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Naomi Hayabusa</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-primary rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          14:30 - 15:30
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Team Backlog Grooming Session
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Bob Harris</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-info rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          13:00 - 14:00
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Project Review & Testing
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Yannis Gloverson</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                  </div>
                  <div id='kt_schedule_day_6' className='tab-pane fade show'>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-success rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          13:00 - 14:00
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Committee Review Approvals
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Karina Clarke</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-info rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          16:30 - 17:30
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          9 Degree Project Estimation Meeting
                        </Link>
                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Karina Clarke</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-warning rounded top-0 start-0'></div>
                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          9:00 - 10:00
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>
                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Committee Review Approvals
                        </Link>
                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Michael Walters</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                  </div>
                  <div id='kt_schedule_day_7' className='tab-pane fade show'>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-primary rounded top-0 start-0'></div>
                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          12:00 - 13:00
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>
                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Committee Review Approvals
                        </Link>
                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>David Stevenson</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-primary rounded top-0 start-0'></div>
                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          14:30 - 15:30
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Creative Content Initiative
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Terry Robins</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-warning rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          11:00 - 11:45
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Committee Review Approvals
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Yannis Gloverson</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                  </div>
                  <div id='kt_schedule_day_8' className='tab-pane fade show'>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-success rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          14:30 - 15:30
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>
                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Team Backlog Grooming Session
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Peter Marcus</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-warning rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          11:00 - 11:45
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Lunch & Learn Catch Up
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Walter White</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-success rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          13:00 - 14:00
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Creative Content Initiative
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Yannis Gloverson</Link>
                        </div>
                      </div>

                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                  </div>

                  <div id='kt_schedule_day_9' className='tab-pane fade show'>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-success rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          10:00 - 11:00
                          <span className='fs-7 text-gray-500 text-uppercase'>am</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Project Review & Testing
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Walter White</Link>
                        </div>
                      </div>

                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>

                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-warning rounded top-0 start-0'></div>
                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          12:00 - 13:00
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Weekly Team Stand-Up
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Caleb Donaldson</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                    <div className='d-flex flex-stack position-relative my-6'>
                      <div className='position-absolute h-100 w-4px bg-info rounded top-0 start-0'></div>

                      <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'>
                          12:00 - 13:00
                          <span className='fs-7 text-gray-500 text-uppercase'>pm</span>
                        </div>

                        <Link to='#' className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>
                          Committee Review Approvals
                        </Link>

                        <div className='text-gray-500'>
                          Lead by
                          <Link to='#'>Caleb Donaldson</Link>
                        </div>
                      </div>
                      <Link to='#' className='btn btn-bg-light btn-active-color-primary btn-sm'>
                        View
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    )
  } else {
    return (
      <div className='card' id='kt_contacts_main' style={{ height: '100%' }}>
        <div
          className='card d-flex py-20 py-xl-0 justify-content-center align-items-center'
          id='kt_contacts_main'
          style={{ height: '100%' }}
        >
          <div className='text-center align-items-center justify-content-center px-20'>
            <img
              src={toAbsoluteUrl('media/illustrations/contactIllust.png')}
              alt={formatMessage({ id: 'No Contacts' })}
              className='mb-8'
              width={350}
              height={250}
            />
            <h2 className='text-dark fw-bold fs-2 mb-4'>
              {formatMessage({ id: 'Welcome to the Contacts App' })}
            </h2>

            <p className='text-gray-800 fs-8 text-center'>
              {formatMessage({
                id: "It's time to expand our contacts. Kickstart your contacts growth by adding a your next contacts.",
              })}
            </p>

            <Link
              to='#'
              className='btn btn-primary text-dark fw-normal mt-2'
              onClick={() => {
                setIsNewContactActive('Add')
              }}
            >
              {formatMessage({ id: 'Add New Contact' })}
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
